export default "__VITE_ASSET__CjeKD3bW__"